import React, {useState} from 'react';
import {Link, NavLink} from 'react-router-dom';
import './FoundationNavBar.css';

function FoundationNavBar() {
    return (
        <>
        <div className='foundation-container'>
            <nav className="navbar">
                <div className="navbar-container">
                    <ul className="nav-menu">
                        <li className="nav-item">
                            <NavLink to="/foundation-component" className="nav-links" activeClassName="is-active" exact={true}>Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/foundation-tech-primers" className="nav-links" activeClassName="is-active">Technology Foundational Primers</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/foundation-func-primers"  className="nav-links" activeClassName="is-active">Functional Foundational Primers</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/foundation-contact"  className="nav-links" activeClassName="is-active">Contact</NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
        </>
    )
}

export default FoundationNavBar
